import { Amplify } from 'aws-amplify';

const cognitoUserPoolId = process.env.COGNITO_USER_POOL_ID;
const cognitoClientId = process.env.COGNITO_CLIENT_ID;
const cognitoDomain = process.env.COGNITO_DOMAIN;

const config = {
  Auth: {
    region: 'ap-southeast-2',
    userPoolId: cognitoUserPoolId,
    userPoolWebClientId: cognitoClientId,
    oauth: {
      domain: cognitoDomain,
      scope: [
        'openid',
        'email',
      ],
      redirectSignIn: `${window.location.protocol}//${window.location.host}`,
      redirectSignOut: `${window.location.protocol}//${window.location.host}`,
      responseType: 'code',
    }
  }
}

export { config };